import { takeEvery } from 'redux-saga/effects';

import * as actionTypes from 'store/modules/listing/actionTypes';

import { removeExtraLocation } from './utils';

export default function* listenRemoveExtraLocation() {
  yield takeEvery(actionTypes.REMOVE_EXTRA_LOCATION, removeExtraLocation);
}
